var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6341 7.22614C18.8195 7.22614 19.7804 6.26675 19.7804 5.08329C19.7804 3.89982 18.8195 2.94043 17.6341 2.94043C16.4487 2.94043 15.4877 3.89982 15.4877 5.08329C15.4877 6.26675 16.4487 7.22614 17.6341 7.22614Z",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6341 10.4404C15.3368 10.4404 12.7583 11.8346 12.5366 12.3154C12.3549 12.7095 12.2683 13.9226 12.2683 13.9226C12.2683 14.3655 12.6279 14.7261 13.0716 14.7261H22.1966C22.6403 14.7261 23 14.3655 23 13.9226C23 13.9226 22.9134 12.7095 22.7317 12.3154C22.51 11.8346 19.9315 10.4404 17.6341 10.4404V10.4404Z",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51204 7.10273C10.1078 7.10273 11.4013 5.81124 11.4013 4.21811C11.4013 2.62498 10.1078 1.3335 8.51204 1.3335C6.91632 1.3335 5.62273 2.62498 5.62273 4.21811C5.62273 5.81124 6.91632 7.10273 8.51204 7.10273Z",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.512 10.5645C5.29571 10.5645 1.68582 12.4412 1.37542 13.0885C1.12104 13.619 0.999809 15.252 0.999809 15.252C0.999809 15.8482 1.50333 16.3337 2.12446 16.3337H14.8995C15.5207 16.3337 16.0242 15.8482 16.0242 15.252C16.0242 15.252 15.903 13.619 15.6486 13.0885C15.3382 12.4412 11.7283 10.5645 8.512 10.5645Z",
    fill: "#F8F9FB",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.2f8dfeee.svg";
export { ForwardRef as ReactComponent };